export default [
  { type: "ZCTAList",
    title: "ZIP Code Tabulation Areas (ZCTA)",
    layout:{
       w: 12,
       h: 9,
       x: 0
    }
  },
  { type: "UNSDList",
    title: "Unified School Districts",
    layout:{
       w: 12,
       h: 9,
       x: 0
    }
  }
]
